module.exports = __webpack_public_path__ + "src/assets/img/hxjs_hxjs_gyl_02@2x.97fa1aae.png";